/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCenterBookableSchedule
 */
export interface ClaimCenterBookableSchedule {
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    localEndTime: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    localStartTime: string;
    /**
     * ISO8601 local date string , e.g. 2025-04-16
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    localEndDate: string;
    /**
     * ISO8601 local date string, e.g. 2025-04-16
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    localStartDate: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimCenterBookableSchedule
     */
    dayOfWeek: number;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    claimCenterBookableId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimCenterBookableSchedule
     */
    id: string;
}

/**
 * Check if a given object implements the ClaimCenterBookableSchedule interface.
 */
export function instanceOfClaimCenterBookableSchedule(value: object): value is ClaimCenterBookableSchedule {
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('localEndDate' in value) || value['localEndDate'] === undefined) return false;
    if (!('localStartDate' in value) || value['localStartDate'] === undefined) return false;
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('claimCenterBookableId' in value) || value['claimCenterBookableId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimCenterBookableScheduleFromJSON(json: any): ClaimCenterBookableSchedule {
    return ClaimCenterBookableScheduleFromJSONTyped(json, false);
}

export function ClaimCenterBookableScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookableSchedule {
    if (json == null) {
        return json;
    }
    return {
        
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'localEndDate': json['localEndDate'],
        'localStartDate': json['localStartDate'],
        'dayOfWeek': json['dayOfWeek'],
        'claimCenterBookableId': json['claimCenterBookableId'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function ClaimCenterBookableScheduleToJSON(value?: ClaimCenterBookableSchedule | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'localEndDate': value['localEndDate'],
        'localStartDate': value['localStartDate'],
        'dayOfWeek': value['dayOfWeek'],
        'claimCenterBookableId': value['claimCenterBookableId'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

